import { FetchError } from 'ofetch';

export const handleFetchError = (
	error: unknown,
	title: string,
	defaultMessage: string,
	statusMessages: Record<number, string>
) => {
	if (error instanceof FetchError && error.statusCode) {
		const message = statusMessages[error.statusCode] || statusMessages[600] || defaultMessage || 'An error occurred';
		if (message === 'useStatusMessage' && error.statusMessage) {
			toastError(title, error.statusMessage);
		} else {
			toastError(title, message);
		}
	} else {
		toastError(title, defaultMessage);
	}
};
